import { render, staticRenderFns } from "./ComparisonBadge.vue?vue&type=template&id=6dc40488&"
import script from "./ComparisonBadge.vue?vue&type=script&lang=js&"
export * from "./ComparisonBadge.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports